export default __webpack_public_path__ + "static/featured-blog-3-836966dc3070cd71ba6ec4c34615119f.png";